if (window.location.pathname === "/Booking/Review") {

    let timeout;
    window.onbeforeunload = function (e) {
        timeout = setTimeout(function () {
            //Prévient le unload de rouler lorsque l'on clique sur cancel
        }, 1000);
        return "Are you sure?";
    }

    window.onunload = function (e) {
        clearTimeout(timeout);
        let uid = $("#uid").length ? $("#uid").val() : $("[name=uid]").val();
        var data = {
            action: 'rollback',
            uniqueId: uid
        };

        //rollback le changement si on quitte la page sans sauvegarder
        $.ajax({
            url: '/api/Booking',
            type: 'POST',
            data: JSON.stringify(data),
            beforeSend: function (e) {
                var now = new Date();
                Cookies.set(uid, Date(now.getTime()));
            },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'

        });
    }

    //Annule le unload et le beforeunload pour la soumission du formulaire
    $('form').each(function (index, form) {
        $(form).on('submit', function (e) {
            window.onbeforeunload = null;
            window.onunload = null;
        });
    });

}